import React, { useEffect, useState } from 'react';
import { HashRouter as Router, Route,Switch} from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { getRemotedbUrl, i18nIntl } from '../../lib/ep.js';

import FloatingLayer from '../builder/FloatingLayer.js';
import ActionLink from '../builder/ActionLink.js';
import CountryFlag from '../builder/CountryFlag.js';
import ModuleHeader from '../ui_items/ModuleHeader.js';
import CopyLink from '../builder/CopyLink.js';
import NavigationTabs from '../builder/NavigationTabs.js';
import Tooltip from '../builder/Tooltip.js';
import Loader from '../builder/Loader.js';
import BlockItem from './BlockItem.js';
import { AlertsTable, DomainsTable, UsersTable } from './DataTables.js';
import ActionButton from '../builder/ActionButton.js';

const DataWrapper = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	if(props?.is_loading ?? false) {
		return (
			<div class="tabbed_registered_section">
				<NavigationTabs
					active={props?.active ?? ''}
					sections={props?.sections ?? []}
					display_type='tab'
				/>

				<div class="gui_not_in_top_big gui_not_in_bottom_small">
					<Loader />
				</div>
			</div>
		)
	}

	if((props?.is_error ?? false)) {
		return (
			<div class="tabbed_registered_section">
				<NavigationTabs
					active={props?.active ?? ''}
					sections={props?.sections ?? []}
					display_type='tab'
				/>

				<div class="gui_not_in_top_big gui_not_in_bottom_small knk-alert redIcon gui_small_icon">
					{i18n("There has been an unexpected error.")}
				</div>
			</div>
		)
	}

	return (
		<div class="tabbed_registered_section">
			<NavigationTabs
				active={props?.active ?? ''}
				sections={props?.sections ?? []}
				display_type='tab'
			/>

			<div class="tab_contents">
				{props.children}
			</div>
		</div>
	)
};

const IPDetail = ({ item, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	
	const [ loading_users, setLoadingUsers ] = useState(false);
	const [ loading_users_error, setLoadingUsersError ] = useState(false);
	const [ users, setUsers ] = useState([]);
	const [ domains, setDomains ] = useState([]);
	const [ country, setCountry ] = useState(props?.country ?? null);
	const [ display_layer, setDisplayLayer ] = useState(false);
	const [ is_blocked, setIsBlocked ] = useState(props?.is_blocked ?? false);

	const basename = props?.basename ?? 'alerts';

	const openLayer = () => {
		setLoadingUsers(true);
		setLoadingUsersError(false);
		window.location.hash = basename;
		
		$.post(getRemotedbUrl(`/users/participants_from/${props.promotion_id}`), { ip:item, country, type:'ip' }, (res) => {
			if(res.data) setUsers(res.data);
			if(res.country_id && res.country_id != props.country) setCountry(res.country_id);
			setLoadingUsers(false);
		}, 'JSON').fail(() => {
			setLoadingUsers(false);
			setLoadingUsersError(true);
		});

		setDisplayLayer(true);
	};

	useEffect(() => {
		if(users.length > 0) {
			const _domains = users.reduce((acc, obj) => {
				const regex = /@(.+)/;
				if(!obj.email)return null;
				const match = (obj?.email ?? '').match(regex);
				const domain = match ? match[1] : false;
				if(!domain)return null;
				if(!acc)acc={};
				if (!acc[domain]) {
					acc[domain] = { domain, total: 0 };
				}
				acc[domain].total++;
				return acc;
			}, {});
			if(!_domains || _domains.length == 0)return ;
			setDomains(Object.values(_domains).sort((a, b) => b.total - a.total));
		}
	}, [ users ]);

	const block = () => {
		setIsBlocked(true);
		props.onBlock();
	};

	const unblock = () => {
		setIsBlocked(false);
		props.onUnblock();
	};

	const closeLayer = () => {
		setUsers([]);
		window.location.hash = basename;

		setDisplayLayer(false);
	};

	if(item == undefined || item == '') {
		return (
			<>-</>
		)
	}

	const alerts = props?.alerts ?? [];
	const all_alerts = props?.all_alerts ?? [];

	const sections = [{
		label:`${i18n("Users")}${(users.length > 0) ? ` [${users.length}]` : ''}`,
		link:`${basename}/`,
		icon:'knk-users',
		key:'users',
	}, {
		label:`${i18n("Domains")}${(domains.length > 0) ? ` [${domains.length}]` : ''}`,
		link:`${basename}/domains`,
		icon:'knk-networks',
		key:'domains',
	}, {
		label:`${i18n("Blocked actions")} [${alerts.length}]`,
		link:`${basename}/alerts`,
		icon:'knk-alert',
		key:'alerts',
	}];

	const data_wrapper_props = {
		sections,
		is_loading:loading_users,
		is_error:loading_users_error,
		intl:props.intl,
	};

	const CallerComponent = ((props?.caller_type ?? 'link') == 'link') ? ActionLink : ActionButton;

	return (
		<>
			<CallerComponent
				children={item}
				{...props.caller_props}
				onClick={openLayer}
			/>

			{(display_layer) && (
				<FloatingLayer backButton={closeLayer}>
					<div class="without_actions">
						<ModuleHeader
							actions={<>
								<CountryFlag
									country_id={country}
									_class={{ first:true, other:'gui_not_in_end_small' }}
									tooltip={<Tooltip with_icon={false} position='top'>{country}</Tooltip>}
								>Connection country</CountryFlag>

								<BlockItem
									type='ip'
									is_blocked={is_blocked}
									item={item}
									promotion_id={props.promotion_id}
									onBlock={block}
									onUnblock={unblock}
								>{(!is_blocked) ? "Block IP" : "Unblock IP"}</BlockItem>
							</>}
							autotranslate={false}
							_class={{ other:'gui_not_in_bottom_big' }}
						>{`${i18n("IP")}: ${item}`}<span style={{ '--bold-font':'400' }}> (<CopyLink copy_link={item} />)</span></ModuleHeader>

						<Router hashType="noslash" basename={basename}>
							<Switch>
								<Route exact={true} path='/alerts' render={(route) => {
									return (
										<DataWrapper
											active='alerts'
											{...data_wrapper_props}
											is_loading={false}
											is_error={false}
										>
											<AlertsTable
												items={alerts}
											/>
										</DataWrapper>
									)
								}} />

								<Route exact={true} path='/domains' render={(route) => {
									return (
										<DataWrapper
											active='domains'
											{...data_wrapper_props}
										>
											<DomainsTable
												items={domains}
												alerts={all_alerts}
											/>
										</DataWrapper>
									)
								}} />
								<Route exact={true} path='/:userpath?' render={(route) => {
									return (
										<DataWrapper
											active='users'
											{...data_wrapper_props}
										>
											<UsersTable
												basename={`${basename}/`}
												items={users}
											/>
										</DataWrapper>
									)
								}} />

							</Switch>
						</Router>
					</div>
				</FloatingLayer>
			)}
		</>
	)
};

export default injectIntl(IPDetail);